'use client';

import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { getProviderLogoUrl, getInitials } from '@/lib/integrations/utils';
import { cn } from '@/lib/utils';

interface ProviderLogoProps {
  provider: string;
  displayName?: string;
  logoUrl?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'size-8',
  md: 'size-10',
  lg: 'size-12',
};

export function ProviderLogo({
  provider,
  displayName,
  logoUrl,
  size = 'md',
  className,
}: ProviderLogoProps) {
  const initials = getInitials(displayName || provider);
  const src = getProviderLogoUrl(provider, logoUrl);

  return (
    <Avatar className={cn(sizeClasses[size], className)}>
      <AvatarImage src={src} alt={displayName || provider} />
      <AvatarFallback className="text-xs font-medium">{initials}</AvatarFallback>
    </Avatar>
  );
}
